import styled from "styled-components";

export const LiveGameContainerDefaultBox = styled.div`

    flex-shrink: 0;
    width: calc(100% / 4);
    padding: 1rem 0.5rem 3rem 0.5rem;

    @media ${props => props.theme.mediaQuery.sAndBelow} {
        width: calc(100% / 2);
        padding: 1rem 0.5rem;
    }
`;
